import { useEffect, useState } from "react";

import { Button } from "../ui/button";
import {
  Dialog,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogPanel,
  DialogPopup,
  DialogTitle,
} from "../ui/dialog";
import { Textarea } from "../ui/textarea";

export const BRAIN_ADD_TEXT_PLACEHOLDER =
  "Paste the material, or a link to it. The Brain captures both.";

/**
 * Captures one Ingest text source. A pasted URL goes through here too: the
 * Ingest Skill Bundle fetches URL material from the supplied text, so a second
 * URL affordance would only split the same paste in two.
 */
export function BrainAddTextDialog(props: {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly onAdd: (text: string) => void;
}) {
  const [text, setText] = useState("");
  useEffect(() => {
    if (props.open) setText("");
  }, [props.open]);
  const ready = text.trim().length > 0;
  const add = () => {
    if (!ready) return;
    props.onAdd(text.trim());
    props.onOpenChange(false);
  };

  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogPopup data-brain-add-text-dialog>
        <DialogHeader>
          <DialogTitle>Add text</DialogTitle>
          <DialogDescription>
            Pasted text and links become raw sources alongside the files you attach.
          </DialogDescription>
        </DialogHeader>
        <DialogPanel>
          <Textarea
            autoFocus
            rows={8}
            value={text}
            aria-label="Text to ingest"
            placeholder={BRAIN_ADD_TEXT_PLACEHOLDER}
            onChange={(event) => setText(event.target.value)}
            onKeyDown={(event) => {
              if (event.key !== "Enter" || !(event.metaKey || event.ctrlKey)) return;
              event.preventDefault();
              add();
            }}
          />
        </DialogPanel>
        <DialogFooter>
          <Button variant="ghost" onClick={() => props.onOpenChange(false)}>
            Cancel
          </Button>
          <Button disabled={!ready} onClick={add}>
            Add
          </Button>
        </DialogFooter>
      </DialogPopup>
    </Dialog>
  );
}
